import type { EventProps } from './shippers/types';

export function getBrowserInfo(): EventProps {
  if (typeof navigator === 'undefined') {
    return {};
  }

  const nav = navigator as Navigator & {
    userAgentData?: {
      platform?: string;
      brands?: Array<{ brand: string; version: string }>;
      mobile?: boolean;
    };
    platform?: string;
  };

  const uaData = nav.userAgentData;

  if (uaData) {
    const brands = uaData.brands || [];
    const realBrand = brands.find((b) => !/Not.*A.*Brand/i.test(b.brand));
    const raw = realBrand?.brand || brands[0]?.brand || '';

    const browser = raw === 'Google Chrome' ? 'Chrome' : raw === 'Microsoft Edge' ? 'Edge' : raw || 'unknown';

    return {
      os: uaData.platform || 'unknown',
      browser
    };
  }

  const ua = nav.userAgent || '';
  const plat = nav.platform || '';

  if (!ua && !plat) {
    return { os: 'unknown', browser: 'unknown' };
  }

  const isAndroidUA = /Android/.test(ua);
  const isIOSUA = /\b(iPad|iPhone|iPod)\b/.test(ua);

  const os = /Win/.test(plat)
    ? 'Windows'
    : /Mac/.test(plat)
      ? 'macOS'
      : /iPhone|iPad|iPod/.test(plat) || isIOSUA
        ? 'iOS'
        : isAndroidUA || /Android/.test(plat)
          ? 'Android'
          : /Linux/.test(plat)
            ? 'Linux'
            : /CrOS/.test(ua)
              ? 'Chrome OS'
              : /Windows/.test(ua)
                ? 'Windows'
                : /Mac OS X|Macintosh/.test(ua)
                  ? 'macOS'
                  : /Linux/.test(ua)
                    ? 'Linux'
                    : 'unknown';

  const browser = /Edg\//.test(ua)
    ? 'Edge'
    : /OPR\//.test(ua)
      ? 'Opera'
      : /Chrome\//.test(ua) && !/Edg|OPR/.test(ua)
        ? 'Chrome'
        : /Firefox\//.test(ua)
          ? 'Firefox'
          : /Safari\//.test(ua) && !/Chrome/.test(ua)
            ? 'Safari'
            : /MSIE|Trident/.test(ua)
              ? 'IE'
              : 'unknown';

  return { os, browser };
}
